import { useAuthContext } from 'components/Login/hooks';
import { Profile } from './types';

interface ProfileHook {
  profile?: Profile;
  profileId: string;
}

const useProfile = (): ProfileHook => {
  const { data: authContext } = useAuthContext();

  let selected;
  if (Array.isArray(authContext?.profiles)) {
    if (authContext?.defaultProfile) {
      selected = authContext?.profiles?.find(
        (p: Profile) => p?.id === authContext?.defaultProfile,
      );
    }
    if (
      !selected &&
      authContext?.profiles &&
      authContext?.profiles?.length > 0
    ) {
      selected = authContext?.profiles[0];
    }
  }

  return {
    profile: selected,
    profileId: selected?.id || '',
  };
};

export default useProfile;
